<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.66683 2.66699H13.3335C14.0668 2.66699 14.6668 3.26699 14.6668 4.00033V12.0003C14.6668 12.7337 14.0668 13.3337 13.3335 13.3337H2.66683C1.9335 13.3337 1.3335 12.7337 1.3335 12.0003V4.00033C1.3335 3.26699 1.9335 2.66699 2.66683 2.66699Z" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.6668 4L8.00016 8.66667L1.3335 4" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>

<script>
export default {
}
</script>